import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { EnumIroStatus, EnumIroType, useGetAccountQuery, useUpdateAccountMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'riskAndOpportunities',
  setup: function setup(__props) {
    var _account$value, _account$value2, _account$value3;
    var dataTableIro = ref(null);
    onMounted(function () {
      var _dataTableIro$value, _dataTableIro$value$r;
      dataTableIro === null || dataTableIro === void 0 ? void 0 : (_dataTableIro$value = dataTableIro.value) === null || _dataTableIro$value === void 0 ? void 0 : (_dataTableIro$value$r = _dataTableIro$value.refetch) === null || _dataTableIro$value$r === void 0 ? void 0 : _dataTableIro$value$r.call(_dataTableIro$value);
    });
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var series = ref([{
      name: '',
      // FIXME: not sure if this is a bug, we have to set at least one data point in order to show the annotations.
      data: [[0, 0]]
    }]);
    var onResult = function onResult(_ref) {
      var _data$listIros;
      var data = _ref.data;
      if (data !== null && data !== void 0 && (_data$listIros = data.listIros) !== null && _data$listIros !== void 0 && _data$listIros.length) {
        var _data$listIros2, _data$listIros3;
        series.value = [{
          name: $i18n.t('modules.csrd.risk'),
          data: (data === null || data === void 0 ? void 0 : (_data$listIros2 = data.listIros) === null || _data$listIros2 === void 0 ? void 0 : _data$listIros2.filter(function (iro) {
            return iro.type === EnumIroType.Risk;
          }).map(function (x) {
            return [x.likelihood || 0, x.magnitude || 0, x.name];
          })) || []
        }, {
          name: $i18n.t('modules.csrd.opportunity'),
          data: (data === null || data === void 0 ? void 0 : (_data$listIros3 = data.listIros) === null || _data$listIros3 === void 0 ? void 0 : _data$listIros3.filter(function (iro) {
            return iro.type === EnumIroType.Opportunity;
          }).map(function (x) {
            return [x.likelihood || 0, x.magnitude || 0, x.name];
          })) || []
        }];
        console.log('update series', series.value);
      }
    };
    var ventureId = useVentureId();
    var _useUpdateAccountMuta = useUpdateAccountMutation({}),
      updateAccount = _useUpdateAccountMuta.mutate,
      loading = _useUpdateAccountMuta.loading;
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId === null || ventureId === void 0 ? void 0 : ventureId.value
      }),
      result = _useGetAccountQuery.result,
      onAccountResult = _useGetAccountQuery.onResult;
    onAccountResult(function (_ref2) {
      var _data$getAccount, _data$getAccount2, _data$getAccount3;
      var data = _ref2.data;
      if (!(data !== null && data !== void 0 && data.getAccount)) {
        return;
      }
      csrdLikelihoodThreshold.value = (_data$getAccount = data.getAccount) === null || _data$getAccount === void 0 ? void 0 : _data$getAccount.csrdLikelihoodThreshold;
      csrdMagnitudeThreshold.value = (_data$getAccount2 = data.getAccount) === null || _data$getAccount2 === void 0 ? void 0 : _data$getAccount2.csrdMagnitudeThreshold;
      csrdThresholdReason.value = (_data$getAccount3 = data.getAccount) === null || _data$getAccount3 === void 0 ? void 0 : _data$getAccount3.csrdThresholdReason;
    });
    var account = computed(function () {
      var _result$value;
      return result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
    });
    var csrdLikelihoodThreshold = ref(account === null || account === void 0 ? void 0 : (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.csrdLikelihoodThreshold);
    var csrdMagnitudeThreshold = ref(account === null || account === void 0 ? void 0 : (_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.csrdMagnitudeThreshold);
    var csrdThresholdReason = ref(account === null || account === void 0 ? void 0 : (_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.csrdThresholdReason);
    var route = useRoute();
    var statusFilter = computed(function () {
      var _route$query, _route$query4;
      if (((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.iroStatus) === 'assessed') {
        var _route$query2, _route$query3;
        if (((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.materialFilter) === 'material') {
          return [EnumIroStatus.Material];
        }
        if (((_route$query3 = route.query) === null || _route$query3 === void 0 ? void 0 : _route$query3.materialFilter) === 'notMaterial') {
          return [EnumIroStatus.NotMaterial];
        } else {
          return [EnumIroStatus.Material, EnumIroStatus.NotMaterial];
        }
      } else if (((_route$query4 = route.query) === null || _route$query4 === void 0 ? void 0 : _route$query4.iroStatus) === 'notAssessed') {
        return [EnumIroStatus.NotAssessed];
      } else {
        return [];
      }
    });
    var showPanel = ref(false);
    return {
      __sfc: true,
      dataTableIro: dataTableIro,
      $i18n: $i18n,
      series: series,
      onResult: onResult,
      ventureId: ventureId,
      updateAccount: updateAccount,
      loading: loading,
      result: result,
      onAccountResult: onAccountResult,
      account: account,
      csrdLikelihoodThreshold: csrdLikelihoodThreshold,
      csrdMagnitudeThreshold: csrdMagnitudeThreshold,
      csrdThresholdReason: csrdThresholdReason,
      route: route,
      statusFilter: statusFilter,
      showPanel: showPanel,
      EnumIroType: EnumIroType
    };
  }
});